import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'popper.js'
import 'bootstrap'
import './assets/custom.scss'
import './assets/common.scss'
import '../public/tes.css'
import Vuex from "vuex"
import VueSplide from '@splidejs/vue-splide';


import {BIconCircleFill, BIconPlusSquareFill,BIconCheck2Square, BIconX, BIconXCircleFill, BIconXSquare} from "bootstrap-icons-vue"
import LoadScript from "vue-plugin-load-script";

createApp(App).use(store).use(router).use(Vuex).use(LoadScript).use(VueSplide).mount('#app')

